var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-bar"},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index,class:['item', _vm.active == index ? 'active' : ''],on:{"click":function($event){return _vm.goLink(tab.url)}}},[_vm._v(_vm._s(tab.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }